import { createStore, applyMiddleware } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { createLogger } from 'redux-logger'
import { composeWithDevTools } from 'redux-devtools-extension'
import { persistStore, persistReducer } from 'redux-persist'
import { createStateSyncMiddleware, initMessageListener } from 'redux-state-sync'
import * as localForage from 'localforage'

import migrations, { createMigrate } from '../migrations'
import rootSaga from './rootSaga'
import rootReducer from './rootReducer'

export const { store, persistor } = configurestore()

function configurestore(initialState) {
    console.log('Configuring store')
    // Saga
    const sagaMiddleware = createSagaMiddleware()

    // Logger
    const loggerMiddleware = createLogger({
        predicate: () => false && process.env.NODE_ENV !== 'production'
    })

    // State sync between tabs
    const syncConfig = {
        broadcastChannelOption: { type: 'localstorage' },
        predicate: (action) =>
            !action.type.startsWith('CURSOR.') && // don't sync cursor between tabs
            action.type !== 'persist/PERSIST' &&
            action.type !== 'persist/REHYDRATE' &&
            !(action.meta && action.meta.noSync)
    }

    const syncMiddleware = createStateSyncMiddleware(syncConfig)

    // Persist
    const persistConfig = {
        key: 'treelist-data',
        version: 1,
        blacklist: [],
        throttle: 100,
        storage: localForage,
        migrate: createMigrate(migrations, { debug: true })
    }

    const persistedReducer = persistReducer(persistConfig, rootReducer)

    // Create store
    const middlewares = [loggerMiddleware, syncMiddleware, sagaMiddleware]
    const composeEnhancers = composeWithDevTools({ trace: true, traceLimit: 25 })
    const store = createStore(persistedReducer, initialState, composeEnhancers(applyMiddleware(...middlewares)))

    // Persist store object
    const persistor = persistStore(store)

    // Run sync between tabs
    initMessageListener(store)

    // Run saga
    let sagaTask = sagaMiddleware.run(rootSaga)

    // Hot replace reducers and sagas
    if (module.hot) {
        module.hot.accept('../ducks', () => {
            const nextRootReducer = require('./rootReducer')
            store.replaceReducer(nextRootReducer)
        })
        module.hot.accept('../ducks', () => {
            const getNewSagas = require('./rootSaga')
            sagaTask.cancel()
            sagaTask.toPromise().then(() => {
                sagaTask = sagaMiddleware.run(function* replacedSaga(_action) {
                    yield getNewSagas()
                })
            })
        })
    }

    return { store, persistor }
}
